/* unplugin-vue-components disabled */import { render } from "./container_order_detail.vue?vue&type=template&id=0613f218&scoped=true"
import script from "./container_order_detail.vue?vue&type=script&lang=js"
export * from "./container_order_detail.vue?vue&type=script&lang=js"

import "./container_order_detail.vue?vue&type=style&index=0&id=0613f218&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0613f218"]])

export default __exports__